module.exports = __webpack_public_path__ + "media/images/my-journey-588f52373b5082bc9b03e8c96247dfe4.jpg";